import { Box } from '@mui/material';

/** Fixed, behind-everything aurora gradient mesh (teal -> indigo). */
export function AuroraBackground() {
  return (
    <Box
      aria-hidden
      sx={(theme) => ({
        position: 'fixed',
        inset: 0,
        zIndex: -1,
        overflow: 'hidden',
        backgroundColor: theme.vars?.palette.background.default ?? 'var(--mui-palette-background-default)',
        '&::before, &::after': {
          content: '""',
          position: 'absolute',
          width: 620,
          height: 620,
          borderRadius: '50%',
          filter: 'blur(120px)',
          opacity: 0.5,
          animation: 'auroraDrift 22s ease-in-out infinite alternate',
        },
        '&::before': {
          top: '-12%',
          left: '-8%',
          background: 'radial-gradient(circle, #14B8A6 0%, transparent 70%)',
        },
        '&::after': {
          bottom: '-16%',
          right: '-10%',
          background: 'radial-gradient(circle, #6366F1 0%, transparent 70%)',
          animationDelay: '-11s',
        },
        '@keyframes auroraDrift': {
          from: { transform: 'translate3d(0,0,0) scale(1)' },
          to: { transform: 'translate3d(40px, 30px, 0) scale(1.15)' },
        },
        '@media (prefers-reduced-motion: reduce)': {
          '&::before, &::after': { animation: 'none' },
        },
        ...theme.applyStyles('light', {
          '&::before, &::after': { opacity: 0.28 },
        }),
      })}
    />
  );
}
